import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';

const DownloadFiles31 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial31/tutorial31.zip?ref_type=heads&inline=false', download: 'tutorial31.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialThirtyOne= () => {

    useEffect(() => {
            window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

<               div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>How to Display a Form and Properly Close the Current Form</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/eN0-zyFeTfM/maxresdefault.jpg"
                            alt="Tutorial 31"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
                        In this PyQt6 tutorial, you'll learn how to display a new form and properly close the current form using QtDesigner and Python. Managing multiple windows or forms is a crucial part of building user-friendly desktop applications. This step-by-step guide will walk you through creating intuitive navigation between forms while ensuring proper resource management and smooth user transitions.
                        <br /><strong>What You'll Learn:</strong>
                        <ul>
                            <li>Creating and designing multiple forms using QtDesigner</li>
                            <li>Displaying a new form from an existing one</li>
                            <li>Properly closing or hiding the current form without leaving orphaned processes</li>
                            <li>Best practices for form management in PyQt6 applications</li>
                        </ul>

                        By the end of this tutorial, you will have the skills to create clean and professional multi-form applications, improving both usability and performance.
                        <br /><br />
                        #Python #PyQt6 #QtDesigner #MultiForm #WindowManagement #CloseForm #GUIProgramming #PythonGUI #DesktopApp #PythonDevelopment #UserExperience #ProgrammingBasics
                    </p>

                    <button className="seemore">
                        <DownloadFiles31 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialThirtyOne;
